import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Data {
  bookingId: string;
  checkIn: string;
  checkOut: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const createDateAmendment = async (
  { bookingId, checkIn, checkOut }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateDateAmendment.Response> => {
  try {
    const { data } = await axios.post<SelfServiceAPI.CreateDateAmendment.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/date-amendment`,
      { checkIn, checkOut },
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await createDateAmendment({ bookingId, checkIn, checkOut }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/date-amendment`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createDateAmendment;
